const FooterListItemPage = ({ page, label }) => (
    <li>
        <Link to={page}>{label}</Link>
    </li>
)

FooterListItemPage.propTypes = {
    page: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
}

export default FooterListItemPage
